import React from 'react';
import classes from './ESMBannerPart.module.css';
import { Desktop, Mobile } from '../../responsive/Responsive';
import BrowseItemsBanner from '../../atoms/BrowseItemsBanner/BrowseItemsBanner';
import { mobileStyle } from '../../Home';
import TagHeading from '../../atoms/TagHeading/TagHeading';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import CountdownTimer from '../CountDown/CountDown';

///this is the component for event, store and marketplace page's banner section

const ESMBannerPart = ({ eventData = {}, image = '', itemType = '', primaryColor = mobileStyle.color[1], showIncomplete = false }) => {

  const navigate = useNavigate()

    const handleAboutCause = (params) => {
      if (eventData?.cause_id){

        navigate(`/about-cause/${eventData?.cause_id}`)
      }else {
        return
      }
  }

  const handleAboutDonor = () => {
    // if (params.itemType === 'marketplace')
      navigate(`/about-donor/${eventData?.donor_id? eventData?.donor_id : eventData?.primary_impact_sale_donor_id}`, );
  }
  return (
    <>
      {/* {console.log("Thisis event data--------->",JSON.stringify(eventData))} */}

      <Mobile>
        {
          <div className={`mp-banner-container ${classes.banner_contianer}`} style={{ backgroundImage: `url(${image})` }}>
            {

              <div style={{ height: '100%', width: '100%' }} className="overlay_white_gradient mp-event-banner-contianer">
                
                <div
                  style={{
                    padding: eventData?.need_box === "1" ? '30px 20px' : '',
                    // backgroundColor: 'black',
                    borderRadius: eventData?.need_box === "1" ? '25px' : '',
                    minHeight: itemType === 'store' ? '200px' : '150px',
                    justifyContent: itemType === 'store' ? 'flex-end' : 'space-between',
                  }}
                  className={`mobile_info_container ${classes.mobile_info_container}`}>

                  
                  {(itemType === 'event') ? new Date(eventData?.start_date) > new Date() ? (
                    <p className="mobile_auction_ends" style={{ color: 'black' }}>
                      {" "}
                      Opens {" "}
                      {moment(eventData?.start_date).format("MMMM Do, YYYY")}
                      {", "}
                      {moment(eventData?.start_date)
                        .tz("America/Los_Angeles")
                        .format("ha z")}
                      .{" "}
                    </p>
                  ) : (
                    <p className="mobile_auction_ends" style={{ color: 'black' }}>
                      {" "}
                      Ends On{" - "}
                      {moment(eventData?.end_date).format("MMMM Do, YYYY")}
                      {", "}
                      {moment(eventData?.end_date)
                        .tz("America/Los_Angeles")
                        .format("ha z")}
                      .{" "}
                    </p>
                  ) : ""}

                  <div className="info_buttons" style={{ color: 'black' }}>
                    { eventData?.donor_id || eventData?.primary_impact_sale_donor_id && <button onClick={handleAboutDonor} style={{ color: 'black',  backgroundColor: '#eff0f3', borderRadius: '15px', padding: '7px 5px', fontSize: '14px', minWidth: '133px' }} className={`info_btn ${classes.info_btn_class}`} >{'About This Brand'}</button>}
                    <button onClick={handleAboutCause} style={{ color: 'black',  backgroundColor: '#eff0f3', borderRadius: '15px', padding: '7px 5px', fontSize: '14px', minWidth: '133px' }} className={`info_btn ${classes.info_btn_class}`}>{'About This Cause'}</button>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        {
          (eventData?.status === "complete") &&
          <div>
            <p
              className={classes.completed_alert}
              style={{ color: mobileStyle.color[0] }}
            >
              This event is now closed.
            </p>
          </div>
        }
      </Mobile>

      <Desktop>
        <>
          <BrowseItemsBanner
            image={image}
            primaryColor={primaryColor}
            gradientClass="overlay_white_gradient"
            desktopImageStyle={{ height: "auto" }}
            params={eventData}
            skeltonStyle={{ height: itemType === 'marketplace' ? '50vh' : '85vh' }}
          >
            {
              <>
                {(itemType === 'store') && <h2 className={classes.desktop_store_heading} style={{ color: 'black', borderBottom: `1px solid black` }}>{eventData?.causeDetails?.legal_name}</h2>}

                <div style={{
                  backgroundColor: 'black'
                }}
                  className={eventData?.need_box === "1" && 'event_custom_box'}>
                  <div className="mobile_info_container " style={{ marginBlock: "0", width: '100%', gap: eventData?.need_box === "1" && '5px' }}>

                    {(itemType === 'event') && <TagHeading heading={eventData?.causeDetails.legal_name} style={{ color: 'black', fontSize: '24px', height: 'auto' }} />}
                    <h1 style={{ color: 'black', position: "relative" }} className="mobile_auction_title" >
                      {eventData?.title}
                      {eventData?.status === "complete" &&
                        <span
                          className={classes.desktop_event_complete_alert}
                          style={{
                            color: 'black',
                          }}
                        >
                          This event is now closed.
                        </span>}
                    </h1>

                    {(itemType === 'event') ? new Date(eventData?.start_date) > new Date() ? (
                      <p className="mobile_auction_ends" style={{ color: 'black' }}>
                        {" "}
                        Opens {" "}
                        {moment(eventData?.start_date).format("MMMM Do, YYYY")}
                        {", "}
                        {moment(eventData?.start_date)
                          .tz("America/Los_Angeles")
                          .format("ha z")}
                        .{" "}
                      </p>
                    ) : (
                      <p className="mobile_auction_ends" style={{ color: 'black' }}>
                        {" "}
                        Ends On{" - "}
                        {moment(eventData?.end_date).format("MMMM Do, YYYY")}
                        {", "}
                        {moment(eventData?.end_date)
                          .tz("America/Los_Angeles")
                          .format("ha z")}
                        .{" "}
                      </p>
                    ) : ""}

                    <div className="info_buttons" style={{ color: 'black' }}>
                     { eventData?.donor_id || eventData?.primary_impact_sale_donor_id &&  <button onClick={handleAboutCause}
                        style={{
                          borderBottom: `1px solid black`,
                          color: 'black',
                          
                        }}
                        className={`info_btn ${classes.info_btn_class}`} >{itemType}{'About This Brand'}</button>}
                    
                      <button onClick={handleAboutCause}
                        style={{
                          borderBottom: `1px solid black`,
                          color: 'black',
                        }}
                        className={`info_btn ${classes.info_btn_class}`}>{'About This Cause'}
                      </button>
                    </div>
              
                  </div>
                </div>
              </>
            }
          </BrowseItemsBanner>
        </>
      </Desktop>
      {
        eventData?.ui === "flash_sale" && itemType === 'store' ? <div>
          <CountdownTimer endTime={eventData?.end_date} isStore={true} discountPercentage={eventData?.discount_percentage} />
        </div> : null
      }
    </>
  )
}

export default ESMBannerPart;